class UtilUrl {
  static encodeUrii (uri) {
    if (uri && uri.length > 0) {
      uri = encodeURIComponent(uri)
    }
    return uri
  }

  static decodeUrii (uri) {
    if (uri && uri.length > 0) {
      uri = decodeURIComponent(uri)
    }
    return uri
  }

  static getPathExt (url) {
    // eslint-disable-next-line no-useless-escape
    return url.split('.').pop().split(/\#|\?/)[0]
  }

  static getPathFilename (url) {
    // eslint-disable-next-line no-useless-escape
    return url.split('/').pop().split(/\#|\?/)[0]
  }

  static openUrl (url, isTargetBlank = true) {
    window.open(url, isTargetBlank ? '_blank' : undefined)
  }

  static getRouterQuery (store, name, extraParams = {}) {
    let params = store.getters.page && store.getters.page.pages[name]
    if (!params) return { name, query: { ...extraParams } }
    if (params.hasOwnProperty('name')) delete params.name
    return { name, query: { ...params, ...extraParams } }
  }
}

export default UtilUrl
